import { useContext } from 'react';

import { AuthContext } from '../../index';
import { AuthContextType } from '../../types';

function useAuth(): AuthContextType {
  return useContext(AuthContext)!;
}

export default useAuth;
